import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Box, Grid, GridItem } from '@chakra-ui/react'

import DefaultLayout from '../../../layouts/DefaultLayout'

import { MdQuestionAnswer } from 'react-icons/md'

// Services
import { contractTemplateServices } from '../../../services/contracts/contractTemplate/index'

// Components
import UpdateDeleteButton from '../../../components/customFormElements/UpdateDeleteButton'
import GeneralCard from '../../../components/cards/generalCard/GeneralCard'
import LoadingComponent from '../../../components/shareds/LoadingComponent'
import DetailCard from '../../../components/cards/detailCard/DetailCard'
import NavCard from '../../../components/cards/navCard/NavigateCard'

const ContractTemplateDetail = () => {
  const [contractTemplateData, setContractTemplateData] = useState<any | null>(null)

  const id = location.pathname.split('/contract-template/')[1]
  const navigate = useNavigate()

  useEffect(() => {
    contractTemplateServices.findOne(id).then((response) => {
      setContractTemplateData(response.data)
    })
  }, [])

  const deleteFunction = (id: string) => {
    contractTemplateServices.remove(id).finally(() => {
      navigate('/contract-template')
    })
  }

  if (!contractTemplateData) {
    return <LoadingComponent />
  }

  return (
    <DefaultLayout>
      <NavCard icon={MdQuestionAnswer} pageName='Contract Template' />

      <GeneralCard title='Contract Template Detail'>
        <Grid templateRows='repeat(2, 1fr)' templateColumns='repeat(4, 1fr)' gap={2} margin={'20px'}>
          <DetailCard upperText='Type' lowerText={contractTemplateData.type} />
          <DetailCard upperText='Language Code' lowerText={contractTemplateData.languageCode} />

          <DetailCard upperText='Description' lowerText={contractTemplateData.description} />

          <GridItem colSpan={4}>
            <Box
              width='100%'
              height='100%'
              overflow='auto'
              dangerouslySetInnerHTML={{
                __html: contractTemplateData ? contractTemplateData.content : '',
              }}
            />
          </GridItem>
        </Grid>
      </GeneralCard>

      <UpdateDeleteButton deleteFunction={deleteFunction} id={id} navigateUrl='/contract-template/update' />
    </DefaultLayout>
  )
}

export default ContractTemplateDetail
